import { render, staticRenderFns } from "./ProductMessages.vue?vue&type=template&id=3609c204&"
import script from "./ProductMessages.vue?vue&type=script&lang=js&"
export * from "./ProductMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports